var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnvelopecirclecheckyellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 640,
    height: 416,
    viewBox: "0 0 640 416",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 0C21.5 0 0 21.5 0 48C0 63.1 7.1 77.3 19.2 86.4L236.8 249.6C248.2 258.1 263.8 258.1 275.2 249.6L332.6 206.6C356.5 146.8 412.3 103.3 478.9 96.8L492.8 86.4C504.9 77.3 512 63.1 512 48C512 21.5 490.5 0 464 0H48ZM294.4 275.2C271.6 292.3 240.4 292.3 217.6 275.2L0 112V320C0 355.3 28.7 384 64 384H360.2C335.1 353.6 320 314.5 320 272C320 266.4 320.3 260.9 320.8 255.4L294.4 275.2ZM640 272C640 233.809 624.829 197.182 597.823 170.177C570.818 143.171 534.191 128 496 128C457.809 128 421.182 143.171 394.177 170.177C367.171 197.182 352 233.809 352 272C352 310.191 367.171 346.818 394.177 373.823C421.182 400.829 457.809 416 496 416C534.191 416 570.818 400.829 597.823 373.823C624.829 346.818 640 310.191 640 272ZM563.3 228.7C569.5 234.9 569.5 245.1 563.3 251.3L491.3 323.3C485.1 329.5 474.9 329.5 468.7 323.3L428.7 283.3C422.5 277.1 422.5 266.9 428.7 260.7C434.9 254.5 445.1 254.5 451.3 260.7L480 289.4L540.7 228.7C546.9 222.5 557.1 222.5 563.3 228.7Z",
    fill: "#FFCD05"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelopecirclecheckyellow);
export default __webpack_public_path__ + "static/media/envelope circle check yellow.a5d849493c77d9711848e0a5e2b61f72.svg";
export { ForwardRef as ReactComponent };